/**
 * Shopping Api
 * The Shopping api
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormGroupModel } from './formGroupModel';


export interface FormCardModel { 
    title: string;
    subTitle: string;
    status: FormCardModel.StatusEnum;
    groups: Array<FormGroupModel>;
}
export namespace FormCardModel {
    export type StatusEnum = 'COMPLETE' | 'INCOMPLETE' | 'WARNING';
    export const StatusEnum = {
        COMPLETE: 'COMPLETE' as StatusEnum,
        INCOMPLETE: 'INCOMPLETE' as StatusEnum,
        WARNING: 'WARNING' as StatusEnum
    };
}


